export default class RealityCheck {
    constructor(api) {
        this.api = api;
        this.RealityCheckClass = null;
    }

    async init(instance) {
        if (!this.RealityCheckClass) {
            if (instance.data && instance.data.cdn && instance.data.cdn.js) {
                await this.api.util.loadJS(instance.data.cdn.js);
            } else if (
                this.api.settings &&
                this.api.settings.nativeMobileApp &&
                this.api.settings.widgetsUrl &&
                this.api.settings.widgetsUrl.realityCheck &&
                this.api.settings.widgetsUrl.realityCheck.js
            ) {
                await this.api.util.loadJS([this.api.settings.widgetsUrl.realityCheck.js]);
            }

            if (instance.data && instance.data.cdn && instance.data.cdn.css) {
                await this.api.util.loadCSS(instance.data.cdn.css);
            } else if (
                this.api.settings &&
                this.api.settings.nativeMobileApp &&
                this.api.settings.widgetsUrl &&
                this.api.settings.widgetsUrl.realityCheck &&
                this.api.settings.widgetsUrl.realityCheck.css
            ) {
                await this.api.util.loadCSS([this.api.settings.widgetsUrl.realityCheck.css]);
            }

            this.RealityCheckClass = new window.Widget_realityCheck.default(this.api, instance.instance);
        }
    }
}
